import type { Component } from 'vue'

type ViewModule = () => Promise<{ default: Component }>

const CHUNK_ERROR_RE =
  /Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk [\d]+ failed|error loading dynamically imported module/i

function reloadOnceForChunkError(): boolean {
  const key = `vite-chunk-reload:${window.location.pathname}`
  if (sessionStorage.getItem(key)) {
    sessionStorage.removeItem(key)
    return false
  }
  sessionStorage.setItem(key, '1')
  window.location.reload()
  return true
}

/** Lazy route loader with one automatic reload when a stale Vite chunk 404s after deploy. */
export function lazyView(loader: ViewModule): ViewModule {
  return () =>
    loader().catch((error: unknown) => {
      const message = error instanceof Error ? error.message : String(error)
      if (CHUNK_ERROR_RE.test(message) && reloadOnceForChunkError()) {
        return new Promise<{ default: Component }>(() => {})
      }
      throw error
    })
}

export function isDynamicImportChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error)
  return CHUNK_ERROR_RE.test(message)
}

export function recoverFromChunkError(fullPath: string): boolean {
  const key = `vite-chunk-reload:${fullPath}`
  if (sessionStorage.getItem(key)) {
    sessionStorage.removeItem(key)
    return false
  }
  sessionStorage.setItem(key, '1')
  window.location.assign(fullPath)
  return true
}
